import {React,useLayoutEffect, useRef,useState} from "react";
import styled  from "styled-components";
import headerImg from './img/headerbackground.jpg';

let loaded = false

let adventureHeight = 0;
let adventureWidth = 0;
let greenOffsetBottom =0;
let IamupHeight =0;

const ContactForm = styled.div`
  position: relative;
  width: 100%;
  padding-top: 20%;
  height: 1500px;
  color: white;
  text-align: center;
  font-family: 'Montserrat ', sans-serif;
  z-index: 1;

  ul{
    position: absolute;
    top: 60%;
    opacity: 1;
  }

  li{
    text-align: center;
    padding: 50px;
    list-style-type: none;
    display: inline-block;
  }
  `

const Intro = styled.div`
  position: relative;
  //background: red ;
  width: 100%;
  color: white;
  z-index: 1;
 // overflow: hidden;


  h1{
 
    position:  sticky; 
    top: 40%;
    font-size: 4em;
    margin-bottom:100px;
  }

  div{
    margin-top:300px;
   //background: green;
    height: 60px;

  }
  `
const Scale = styled.div`

position: relative;
//background: red ;
width: 100%;
color: white;


height: 55vh;

   h2{
    //overflow: hidden
    position:  sticky; 
    top: 40%;
    background: linear-gradient(0deg, rgba(79,100,131,1) 0%, rgba(141,110,126,1) 12%, rgba(223,123,100,1) 26%, rgba(253,150,75,1) 42%, rgba(248,214,176,1) 59%, rgba(162,197,225,1) 78%, rgba(95,134,199,1) 100%);
    background-attachment: fixed;
    background-size: 100%;
    background-position: center top;
    -webkit-background-clip: text;
    color: transparent;
    margin: 0 auto;
    margin-bottom:150px;
    padding: 0; 
    width: fit-content;
    font-size: 50px;
    backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
    line-height: 0.75em;
    transform-origin: bottom right; //50% 50%;
   //background: blue ;

    z-index: 1;
  }
}
`
const ContactTemplate = styled.div`
  position: relative;
  width: 100%;
 height:70vh;
  color: white;
  z-index: 1;
  //background: red;
 
  h1{
  
    top: 10vh;
    opacity: 1;
    margin: auto;
    width: 95%;
    margin-bottom:100px;
  }
  h2{
    margin: auto;
    border-radius: 25px;
    height: 50px;
  line-height: 50px;
    margin-top: 30vh;
    width: 200px;
    top: 40vh;
    margin-bottom:10px;
    background: #ff770f;
    text-align: center;
    opacity: 1;
  }
  h2:hover{
    background: white;
    color: #ff770f;
  }

  @media only screen and (max-width: 500px) {

    h2{
    margin: auto;
    border-radius: 25px;
    height: 50px;
  line-height: 50px;
    margin-top: 20vh;
    width: 200px;
    top: 40vh;
    margin-bottom:10px;
    background: #ff770f;
    text-align: center;
    opacity: 1;
  }
}
`

function Contact(props) {
  let viewPortHeight = window.innerHeight;
  let viewPortWidth = window.innerWidth;

  let [iamupFade, setiamupFade] = useState(1) 
  let [adventureScale, setadventureScale] = useState(1) 
  let [adventureY, setadventureY] = useState(viewPortHeight)
  let [adventureX, setadventureX] = useState(viewPortWidth)  

  let refIamup = useRef()
  let refAdventure =useRef()
  let refGreenElement = useRef()

 



  function mapScale( x,  in_min,  in_max,  out_min,  out_max){ // maps de waarde naar een coma getal met 3 cijfers achter de coma
    return Math.round(((x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min)*100000000000000)/100000000000000
  }



  


  useLayoutEffect(() => {

    // begin settings on page load
    if(loaded === false){// this will run only once 
        adventureWidth = refAdventure.current.clientWidth;
        adventureHeight = refAdventure.current.clientHeight;
        greenOffsetBottom = refGreenElement.current.getBoundingClientRect().y- viewPortHeight


        setadventureY( -greenOffsetBottom)
        setadventureX(viewPortWidth-(adventureWidth/1.3))

       // console.log( -greenOffsetBottom)
        loaded = true 
    }
    


  // fading H1 "I'm up for new" when element is higher dan 40% of viewPortHeiht
   if(refIamup.current.getBoundingClientRect().y <(viewPortHeight*0.45)){

    let h1Y = refIamup.current.getBoundingClientRect().y // Y position of element h1 in Intro

    //console.log(mapScale(h1Y,10,viewPortHeight*0.40,0,1))
    setiamupFade(mapScale(h1Y,10,viewPortHeight*0.20,0,1))
   //console.log("Element is hoger")
   }

     // height of element h2 in <Scale>
     

     //console.log(adventureWidth)
     ///////////////////////////////////////////////////////////////////////////
                  // scale H2 inside <Scale> 
     /////////////////////////////////////////////////////////////////
     // code is built from bottom to top scrolling
     if(refGreenElement.current.getBoundingClientRect().y>viewPortHeight &&refAdventure.current.getBoundingClientRect().y> viewPortHeight ){ // green and blue element below bottom screen

      greenOffsetBottom = refGreenElement.current.getBoundingClientRect().y- viewPortHeight
     // setadventureY(-greenOffsetBottom) 
     // setadventureX(viewPortWidth/2-(refAdventure.current.getBoundingClientRect().width/2)) //set "adventure " in middle of screen
      //setadventureScale(1)
     

      //console.log("kleiner ")
     }
     if(refGreenElement.current.getBoundingClientRect().y>viewPortHeight &&refAdventure.current.getBoundingClientRect().y< viewPortHeight){ // green below blue above 
      greenOffsetBottom = refGreenElement.current.getBoundingClientRect().y- viewPortHeight
      let h1Y = refGreenElement.current.getBoundingClientRect().y // Y position of element h2 in Intro
     
      setadventureScale(mapScale(h1Y,viewPortHeight,0,1,6))
     // setadventureY(-greenOffsetBottom)  
     // console.log("tussen")
     }
      if(refGreenElement.current.getBoundingClientRect().y<viewPortHeight && refIamup.current.getBoundingClientRect().y >(viewPortHeight*0.39)){ // green and blue above and (I'am up for new) is below 39% of screen
        
        let h1Y = refGreenElement.current.getBoundingClientRect().y // Y position of element h2 in Intro
        let xPosistion = mapScale(h1Y,viewPortHeight,350,1,200)
        IamupHeight = refIamup.current.getBoundingClientRect().y
      
        setadventureScale(mapScale(h1Y,viewPortHeight,0,1,7)) 
        //setadventureY(0)
        //setadventureX(viewPortWidth/2-(refAdventure.current.getBoundingClientRect().width/2))  
       // console.log("blue and green above bottom " )
      
     
     }

     if((refIamup.current.getBoundingClientRect().y <(viewPortHeight*0.39)) &&refAdventure.current.getBoundingClientRect().y>(viewPortHeight*0.39)){ // green & blue high and (I,am up for new ) is below 39% of screen
      
      // calculation needed for if page load when already scrolled
      IamupHeight = viewPortHeight/100*39; 

      if(refAdventure.current.getBoundingClientRect().width<(viewPortWidth/100*94)){

        let h1Y = refGreenElement.current.getBoundingClientRect().y // Y position of element h2 in Intro
        let xPosistion = mapScale(h1Y,viewPortHeight,350,1,200)

        setadventureScale(mapScale(h1Y,viewPortHeight,0,1,7)) 
        //setadventureY(IamupHeight-refIamup.current.getBoundingClientRect().y)
        //setadventureX(viewPortWidth/2-(refAdventure.current.getBoundingClientRect().width/2))  
        //setadventureX(viewPortWidth-(adventureWidth/1.3)- xPosistion)

      //  console.log(refAdventure.current.getBoundingClientRect().width)
      }
  
    }
    
  },[props.scrollPercentage, props.viewPortHeight]);


  return (
    <ContactForm>
      <Intro iamupFade={iamupFade}  >
        <h1 ref={refIamup}   style={{opacity: iamupFade}}>I'm up for new</h1 >
        <div ref={refGreenElement} ></div>
      </Intro>
      <Scale dventureScale={adventureScale}>
       
           <h2 ref={refAdventure} style={{ fontSize: `${adventureScale}em`}}>adventures</h2>  {/*  //bottom: adventureY,left: adventureX, */}
      </Scale>
      <ContactTemplate>
        <h1>and I’d like to work with you</h1>
        <h2   onClick={(e) => {window.location.href = "mailto:info@fox-connect.nl"; e.preventDefault(); }}>Contact me</h2>
      </ContactTemplate>
    </ContactForm>
  );
}
export default Contact;